/**
 * A styled Input with search glass on the left and "clear" X on the right
 */
import React, { FunctionComponent } from 'react';
import { Box } from 'rebass/styled-components';

import { ReactComponent as Searchglass } from '../../../assets/searchglass.svg';
import { ReactComponent as CloseIcon } from '../../../assets/close-icon.svg';
import { InputShape } from '.';
import { StyledInput } from './input';

export interface ISearchInputProps {
  onChange: (ev: any) => void;
  value: string;
  onClear: () => void;
  isLeftAdornment?: boolean;
  isRightAdornment?: boolean;
  shape?: InputShape;
  placeholder: string;
  [key: string]: any; // any more props :|
}

const SearchInputV2: FunctionComponent<ISearchInputProps> = ({
  onChange, value, onClear, isLeftAdornment = false, isRightAdornment = false,
  shape = InputShape.ROUND, placeholder, ...rest
}: ISearchInputProps) => (
  <Box sx={{
    position: 'relative',
    width: '100%',
    height: '100%',
  }}
  >
    <StyledInput
      data-testid="text-field"
      onChange={onChange}
      value={value || ''}
      type="text"
      isLeftAdornment={isLeftAdornment}
      isRightAdornment={isRightAdornment}
      shape={shape}
      placeholder={placeholder}
      isLeftInteriorIcon
      {...rest}
    />
    <Box sx={{ position: 'absolute', top: '8px', left: '12px' }}>
      <Searchglass />
    </Box>
    {value && (
      <Box
        sx={{
          position: 'absolute', top: '4px', right: '8px', cursor: 'pointer',
        }}
        onClick={onClear}
      >
        <CloseIcon />
      </Box>
    )}
  </Box>
);

export default SearchInputV2;
